export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const REQUEST_REPAIRE_FORM = 'REQUEST_REPAIRE_FORM';
export const RECEIVE_REPAIRE_FORM = 'RECEIVE_REPAIRE_FORM';

export const REQUEST_CREATE_TICKET = 'REQUEST_CREATE_TICKET';
export const RECEIVE_CREATE_TICKET = 'RECEIVE_CREATE_TICKET';

export const REQUEST_MY_TICKET_LIST = 'REQUEST_MY_TICKET_LIST';
export const RECEIVE_MY_TICKET_LIST = 'RECEIVE_MY_TICKET_LIST';

export const REQUEST_TICKET_DETAIL = 'REQUEST_TICKET_DETAIL';
export const RECEIVE_TICKET_DETAIL = 'RECEIVE_TICKET_DETAIL';

export const REQUEST_USER_INFO = 'REQUEST_USER_INFO';
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
export const REQUEST_SAVE_USER_INFO = 'REQUEST_SAVE_USER_INFO';
export const RECEIVE_SAVE_USER_INFO = 'RECEIVE_SAVE_USER_INFO';
export const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';
export const RECEIVE_CHANGE_PASSWORD = 'RECEIVE_CHANGE_PASSWORD';

export const REQUEST_COMMON_FAULT = 'REQUEST_COMMON_FAULT';
export const RECEIVE_COMMON_FAULT = 'RECEIVE_COMMON_FAULT';

export const REQUEST_SERVICE_TICKET_DETAIL = 'REQUEST_SERVICE_TICKET_DETAIL';
export const RECEIVE_SERVICE_TICKET_DETAIL = 'RECEIVE_SERVICE_TICKET_DETAIL';

export const REQUEST_FETCH_SP_INFO = 'REQUEST_FETCH_SP_INFO';
export const RECEIVE_FETCH_SP_INFO = 'RECEIVE_FETCH_SP_INFO';

export const REQUEST_QUERY_DEVICEINFO = 'REQUEST_QUERY_DEVICEINFO';
export const RECEIVE_QUERY_DEVICEINFO = 'RECEIVE_QUERY_DEVICEINFO';
export const RECEIVE_QUERY_DEVICEINFO_FAIL = 'RECEIVE_QUERY_DEVICEINFO_FAIL';

export const REQUEST_FETCH_TICKET_STEPS = 'REQUEST_FETCH_TICKET_STEPS';
export const RECEIVE_FETCH_TICKET_STEPS = 'RECEIVE_FETCH_TICKET_STEPS';




// WEBPACK FOOTER //
// ./src/store/mutation-types.js